import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { articuloJson } from '../pages/articulo/articulo.json';
import { environment } from 'src/environments/environment';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ArticuloService {

  endpointApi = environment.apiCms;

  articulo: any;

  constructor(private http: HttpClient) { }

  // Handle API errors =================================
  handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('An client error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.log("Backend error code " + error.status + ", body was: " + JSON.stringify(error.error));
    }
    // return an observable with a user-facing error message
    return throwError(() => error.error)
  }

  getArticulo(id: number) {
    this.articulo = this.http.get<any>(this.endpointApi + 'find?id=' + id)
      .pipe(
        map(resp => {
          return resp.data.article;
        }),
        catchError(this.handleError)
      )
    return this.articulo;


    // const res = articuloJson.find(x => x.id == id)
    // return res ? res : null
  }

  getArticuloPreview(id: number) {
    this.articulo = this.http.get<any>(this.endpointApi + 'find?id=' + id)
      .pipe(
        map(resp => {
          return resp.data.article;
        }),
        catchError(this.handleError)
      )
    return this.articulo;

  }




}
